var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"test-button"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.enter}},[_vm._v("Request")])]),_c('div',{staticClass:"test-content"},[_vm._v(_vm._s(_vm.response))])])}
var staticRenderFns = []

export { render, staticRenderFns }